import { ShipmentHistoryFilters, ShipmentsDataTable } from './components';
import { useShipmentHistory } from './hooks';
import './ShipmentHistory.scss';

interface Props {
  isAdmin?: boolean;
}

export default function ShipmentHistory({
  isAdmin = false,
}: Props) {
  const {
    search,
    onChangeSearch,
    shipmentStartDate,
    shipmentEndDate,
    onChangeShipmentDates,
    onChangeShipmentRawDates,
    userEmail,
    onChangeUser,
    selectedJob,
    onSelectJob,
    subAccountNumber,
    onChangeSubAccountNumber,
    shipmentList,
    onChangeStatusFilter,
    selectedStatus,
    loadingShipments,
  } = useShipmentHistory(isAdmin);

  return (
    <div className='ShipmentHistory'>
      <div className='ShipmentHistoryFiltersContainer'>
        <ShipmentHistoryFilters
          search={search}
          onChangeSearch={onChangeSearch}
          shipmentStartDate={shipmentStartDate}
          shipmentEndDate={shipmentEndDate}
          onChangeShipmentDates={onChangeShipmentDates}
          onChangeShipmentRawDates={onChangeShipmentRawDates}
          userEmail={userEmail}
          onChangeUser={onChangeUser}
          subAccountNumber={subAccountNumber}
          onChangeSubAccountNumber={onChangeSubAccountNumber}
          selectedJob={selectedJob}
          onSelectJob={onSelectJob}
          isAdmin={isAdmin}
        />
      </div>
      <div className='DataTableContainer'>
        <ShipmentsDataTable
          shipmentList={shipmentList}
          onChangeStatusFilter={onChangeStatusFilter}
          selectedStatus={selectedStatus}
          loadingShipments={loadingShipments}
          isAdmin={isAdmin}
        />
      </div>
    </div>
  );
}
